export function secondsStringToHoursNumber(time) {
    return Math.round(Number(time.match(/-?\d+/)) / 3600);
}

export function hoursStringToSecondsNumber(time = '') {
    return Math.round(Number(time.match(/-?\d+/)) * 3600);
}
